import React, { Component } from 'react';
import './main.css';
import Logo from './Images/RedLogoLandscape.svg';
import 'dayjs/locale/en-gb';
import Button from './Common/Button';

class App extends Component {


    render() {
       
        return (
            <div className="app__container">
                <img src={Logo} alt="prospector records" className="app__logo" />
                
                <div className="app__actions">
                    <Button link="/dashboard">Artist Dashboard</Button>
                    <Button link="/artist/stetsons">Stetsons</Button>
                </div>
            </div>
        );
    }
}

export default App;
